import NotificationsIcon from '@material-ui/icons/Notifications';

import { ClientNotificationSubscriptionList } from './List/List';
import { ClientNotificationSubscriptionCreate } from './Create/Create';
import { ClientNotificationSubscriptionShow } from './Show/Show';


export {
	ClientNotificationSubscriptionList,
	ClientNotificationSubscriptionShow,
	ClientNotificationSubscriptionCreate,
};


export const clientNotificationSubscriptionResource = {
	list: ClientNotificationSubscriptionList,
	show: ClientNotificationSubscriptionShow,
	create: ClientNotificationSubscriptionCreate,
	icon: NotificationsIcon,
};
